'use strict';

function getNoArgHandler(logger, fn, args) {
    args = args || []; // eslint-disable-line no-param-reassign
    return function () { // eslint-disable-line func-names
        fn.apply(logger, args);
    };
}

function promiseWhenHandler(promise, operation, successLevel, errorLevel, progressLevel) {
    var successLevelFn;
    var errorLevelFn;
    var progressLevelFn;

    if (successLevel == null) successLevel = 'info'; // eslint-disable-line no-param-reassign
    if (errorLevel == null) errorLevel = 'error'; // eslint-disable-line no-param-reassign

    successLevelFn = this[successLevel];
    if (typeof successLevelFn === 'function') {
        promise.then(getNoArgHandler(this, successLevelFn, [operation + '.success']));
    }

    errorLevelFn = this[errorLevel];
    if (typeof errorLevelFn === 'function') {
        promise.catch(errorLevelFn.bind(this, operation + '.failed', 'error='));
    }

    progressLevelFn = this[progressLevel];
    if (typeof progressLevelFn === 'function' && promise.progress) {
        promise.progress(progressLevelFn.bind(this, operation + '.progress', 'progress='));
    }
}
module.exports = {
    pluginName: 'loggerWhen',
    dependencies: ['logger'],

    nodeMethods: {
        when: promiseWhenHandler
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/@getgo/logger/plugins/logger_when.js
// module id = 718
// module chunks = 0